<template>
	<div id="app">
		<!-- <transition name="slide-left" mode="out-in">
      <router-view class="content_view" />
    </transition> -->
		<router-view></router-view>
		<!-- <transition name="fade">
      <router-view></router-view>
    </transition> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		components: {
			
		},
		created() {
			this.$store.commit('yhShowSet',false)
		},
		mounted() {
			let content = localStorage.getItem('i18n-lang') || 'eu';
			document.getElementsByTagName('html')[0].setAttribute('lang', content);
			if (content == 'zh') {
				document.title = '澳华内镜';
			} else if (content == 'en'){
				document.title = 'Aohua Endoscopy1';
			}else{
				document.title = 'Aohua Endoscopy';
			}
			this.setMeta();
			if (location.hostname == 'www.aohua.com'||location.hostname == '192.168.110.191') {
				if(!localStorage.getItem('i18n-lang')){
					localStorage.setItem("i18n-lang", 'eu');
				}
			} else {
				localStorage.setItem("i18n-lang", 'eu');
			}
		},
		methods: {
			setMeta() {
				let userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
				// console.log("BBB", userAgent, "AAA")
				let vid='';
				if (/iPhone|iPad|iPod/.test(userAgent)) {
					window.onload = function() {
						var meta = document.createElement('meta');
						meta.setAttribute('name', 'viewport');
						meta.setAttribute('content',
							'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
						document.head.appendChild(meta);
					}
					vid='iPhone'
				}
				// 对于Android
				if (/Android|webOS|BlackBerry|Opera Mini|IEMobile/.test(userAgent)) {
					window.onload = function() {
						var meta = document.createElement('meta');
						meta.setAttribute('name', 'viewport');
						meta.setAttribute('content',
							'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
						document.head.appendChild(meta);
					}
					vid='Android'
				}
				// 对于Windows Phone
				if (/IEMobile|Windows Phone|ZuneWP|iemobile/i.test(userAgent)) {
					window.onload = function() {
						var meta = document.createElement('meta');
						meta.setAttribute('name', 'viewport');
						meta.setAttribute('content',
							'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
						document.head.appendChild(meta);
					}
					vid='WindowsPhone'
				}
				if(vid){
					this.$store.commit('setVibe',vid);
				}else{
					this.$store.commit('setVibe','pc');
				}
				// 对于Desktop
				// return "Desktop";
			}
		}
	}
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	/* body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

body::-webkit-scrollbar-track {
  --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}
body::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgb(99, 99, 99);
  --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
}

body::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
} */
	/* .slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(100px, 0px);
  transform: translate(-100px, 0px);
}

.slide-left-enter-active {
  transition: all 0.3s linear;
}

.slide-left-leave-to {
  opacity: 0;
  -webkit-transform: translate(-100px, 0px);
  transform: translate(100px, 0px);
}

.slide-left-leave-active {
  transition: all 0.3s linear;
} */



	.fade-enter-active,
	.fade-leave-active {
		/* transition-property: opacity; */
		/* transition-duration: .8s; */
		transition: all 0.6s linear;
	}

	.fade-enter-active {
		transition-delay: .6s;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: .6
	}
	.el-message-box__wrapper{
		display: flex;
		align-items: center;
		padding: 0 30px;
	}
	
</style>